import { EventBusForThirdParty } from '../event-bus'
import { HotelloversLikeEventSubscriptionFacade } from './hotellovers-like'

export class VilbEventSubscriptionFacade extends HotelloversLikeEventSubscriptionFacade {
  protected subscribeHostSpecific(_eventBus: EventBusForThirdParty): void {
    // 美ラボ固有の購読は現状ない
  }
}
